const DB_VERSION = 1

export function createIndexedDbAdapter({ indexedDBImpl = globalThis.indexedDB, name = 'iwb_web_v4' } = {}) {
  let databasePromise
  function open() {
    if (!indexedDBImpl) return Promise.reject(new Error('IndexedDB unavailable'))
    if (!databasePromise) databasePromise = new Promise((resolve, reject) => {
      const request = indexedDBImpl.open(name, DB_VERSION)
      request.onupgradeneeded = () => { const db = request.result; if (!db.objectStoreNames.contains('images')) db.createObjectStore('images', { keyPath: 'imageId' }); if (!db.objectStoreNames.contains('kv')) db.createObjectStore('kv', { keyPath: 'key' }) }
      request.onsuccess = () => resolve(request.result)
      request.onerror = () => reject(request.error)
    })
    return databasePromise
  }
  async function transaction(store, mode, action) {
    const db = await open()
    return new Promise((resolve, reject) => {
      const request = action(db.transaction(store, mode).objectStore(store))
      request.onsuccess = () => resolve(request.result)
      request.onerror = () => reject(request.error)
    })
  }
  return {
    available: () => Boolean(indexedDBImpl),
    putImage(value) { return transaction('images', 'readwrite', (store) => store.put(value)) },
    getImage(imageId) { return transaction('images', 'readonly', (store) => store.get(imageId)) },
    deleteImage(imageId) { return transaction('images', 'readwrite', (store) => store.delete(imageId)) },
    putValue(key, value) { return transaction('kv', 'readwrite', (store) => store.put({ key, value })) },
    getValue(key) { return transaction('kv', 'readonly', (store) => store.get(key)) },
  }
}
